import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class SharedService {
	private spinnerLoader: BehaviorSubject<any> = new BehaviorSubject<any>('Loading...');
	data$: Observable<any> = this.spinnerLoader.asObservable();

	private formDataSubject = new BehaviorSubject<any>(null);
	formData$: Observable<any> = this.formDataSubject.asObservable();

	// Is LoggedIn
	private _isLoggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	_isLoggedIn$ = this._isLoggedIn.asObservable();

	private _setGamePageName: BehaviorSubject<string> = new BehaviorSubject<string>('');
	_setGamePageName$ = this._setGamePageName.asObservable();

	private _setGamePageId: BehaviorSubject<number> = new BehaviorSubject<number>(0);
	_setGamePageId$ = this._setGamePageId.asObservable();

	private _setGamePagesCount: BehaviorSubject<number> = new BehaviorSubject<number>(0);
	_setGamePagesCount$ = this._setGamePagesCount.asObservable();
	
	setFormData(data: any) {
		this.formDataSubject.next(data);
	}

	getFormData(): any {
		return this.formDataSubject.value;
	}

	setSpinner(value: { text: string, isLoading: boolean }): void {
		if (!value.isLoading) setTimeout(() => this.spinnerLoader.next(value), 2000);
		else this.spinnerLoader.next(value);
	}

	spinnerLoading(): Observable<any> {
		return this.data$;
	}

	login() {
		this._isLoggedIn.next(true);
	}

	logout() {
		this._isLoggedIn.next(false);
	}

	setGamePageName(value: string) {
		this._setGamePageName.next(value);
	}

	setGamePageId(value: number) {
		this._setGamePageId.next(value);
	}

	setGamePagesCount(value: number) {
		this._setGamePagesCount.next(value);
	}

}
